module.exports = __webpack_public_path__ + "static/media/checkin.cf327d9a.png";